import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY } from "@/data/content";

export function Footer() {
  return (
    <footer className="bg-secondary text-secondary-foreground mt-24" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <img src="/logo.png" alt="Colnexx" className="h-12 w-12 object-contain bg-white rounded-xl p-1" />
            <span className="font-display text-2xl font-black">COLNEXX</span>
          </div>
          <p className="text-sm text-secondary-foreground/70 max-w-sm leading-relaxed">
            Internet de fibra óptica de alta velocidad. Conectamos hogares y empresas con tecnología de última
            generación y atención cercana.
          </p>
          <p className="text-xs text-secondary-foreground/50 mt-4">{COMPANY.legal} · NIT {COMPANY.nit}</p>
        </div>

        <div>
          <h4 className="font-display font-bold mb-4 text-sm uppercase tracking-widest">Enlaces</h4>
          <ul className="space-y-2 text-sm text-secondary-foreground/70">
            <li><Link to="/informacion" className="hover:text-primary transition-colors">Información importante</Link></li>
            <li><Link to="/pqr" className="hover:text-primary transition-colors">Radicar PQR</Link></li>
            <li><Link to="/medidor" className="hover:text-primary transition-colors">Medidor de velocidad</Link></li>
            <li><Link to="/transparencia" className="hover:text-primary transition-colors">Código de transparencia</Link></li>
            <li><Link to="/admin/login" className="hover:text-primary transition-colors">Acceso administrador</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold mb-4 text-sm uppercase tracking-widest">Atención</h4>
          <ul className="space-y-3 text-sm text-secondary-foreground/70">
            <li className="flex items-start gap-2"><Phone className="h-4 w-4 mt-0.5 text-primary" /> {COMPANY.phone}</li>
            <li className="flex items-start gap-2"><Mail className="h-4 w-4 mt-0.5 text-primary" /> {COMPANY.email}</li>
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-primary" /> {COMPANY.address}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6 text-xs text-secondary-foreground/50 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} {COMPANY.legal}. Todos los derechos reservados.</span>
          <span>Vigilado por la CRC · Régimen de protección de usuarios de servicios de comunicaciones.</span>
        </div>
      </div>
    </footer>
  );
}
